import { useRouter } from 'next/router';
import { useState, useContext, forwardRef, useEffect } from 'react';
import Toggle from 'remote-com-shared/components/HeaderNavigation/Toggle';
import {
  Navigation,
  NavigationSecondary,
} from 'remote-com-shared/components/HeaderNavigation/styles/Navigation';
import HeroContext from 'remote-com-shared/components/Hero/context';
import { useBreakpointRange } from 'remote-com-shared/style/breakpoints';
import styled from 'styled-components';

import { Wrapper, RemoteLogo } from '@/src/components/Header/styles';
import { BrandContainer, Brand } from '@/src/components/Header/styles/Brand';
import { fromDesktopBreakpoint } from '@/src/domains/shared/breakpoints';

const WrapperPosition = styled.div`
  position: relative;
`;

export const Header = forwardRef(function NamedHeader(props, ref) {
  const { LogoSVG = RemoteLogo, brandHref = '/', brandSuffix, children } = props;
  const { isIntersecting } = useContext(HeroContext);
  const [isOpen, setIsOpen] = useState(false);

  function closeNavigation() {
    setIsOpen(false);
  }

  const router = useRouter();

  useBreakpointRange(
    { to: fromDesktopBreakpoint },
    {
      onLeave: () => closeNavigation(),
    }
  );

  useEffect(() => {
    function handleHashChange(event) {
      const { target } = event;
      const { location: { hash: locationHash = '' } = {} } = target || {};
      if (locationHash.length > 0) {
        closeNavigation();
      }
    }

    function handleRouteChange() {
      closeNavigation();
    }

    window.addEventListener('hashchange', handleHashChange, true);
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange, true);
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router]);

  return (
    <WrapperPosition>
      <Wrapper $isOpen={isOpen} $isFixed={!isIntersecting} ref={ref} {...props}>
        <BrandContainer $isOpen={isOpen} $isFixed={!isIntersecting}>
          <Brand as="a" aria-label="Visit homepage" href={brandHref}>
            <LogoSVG $isOpen={isOpen} $isFixed={!isIntersecting} />
            {brandSuffix && brandSuffix({ $isOpen: isOpen, $isFixed: !isIntersecting })}
          </Brand>

          {children && (
            <Toggle
              isOpen={isOpen}
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Open navigation"
            />
          )}
        </BrandContainer>

        {children && (
          <Navigation $isOpen={isOpen} aria-hidden={!isOpen}>
            {children}
          </Navigation>
        )}
      </Wrapper>
    </WrapperPosition>
  );
});

export const WebinarNavigation = ({ children }) => (
  <>
    <NavigationSecondary>{children}</NavigationSecondary>
  </>
);
